<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #sidenav mode="side" class="sidenav-menu">
    <mat-nav-list>
      <ng-container *ngFor="let m of optionsMenu; index as i">
        <div id="option_{{i}}" class="menu-option"  (click)="selectOption(i)" >
                <a mat-list-item
                [routerLink]="m.path"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{exact:true}">
                <mat-icon>{{m.icon}}</mat-icon>
                <span class="sidenav-option" >{{m.opcion}}</span>
              </a>
            </div>
          </ng-container>

          <a (click)="salir()" class="unlock-btn">
            <mat-icon>exit_to_app</mat-icon>
            <span style="color: white">Salir</span>
          </a>

        </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content class="sidenav-content">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
